import React from 'react';

const NoWeights: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#222529"
      fillRule="evenodd"
      d="M16.48 2.507c.671-.67 1.76-.67 2.43 0l2.583 2.584a1.718 1.718 0 0 1-.618 2.825l.187.188a1.718 1.718 0 0 1-2.429 2.43l-5.166-5.167a1.718 1.718 0 0 1 2.43-2.429l.187.188c.083-.226.216-.437.397-.619Zm1.723.708a.718.718 0 0 0-1.015 1.015l2.583 2.583a.718.718 0 0 0 1.015-1.015l-2.583-2.583Zm-3.014.43a.718.718 0 1 0-1.015 1.015l5.166 5.166a.718.718 0 1 0 1.015-1.015L15.19 3.645Zm-4.656 17.417c-.67.67-1.758.67-2.43 0l-.186-.187a1.718 1.718 0 0 1-2.826.618l-2.583-2.584a1.718 1.718 0 0 1 .618-2.825l-.188-.188a1.718 1.718 0 0 1 2.429-2.43l5.166 5.167c.67.67.67 1.758 0 2.429Zm-5.63-4.615L3.645 15.19a.718.718 0 1 1 1.015-1.015l5.166 5.166a.718.718 0 0 1-1.015 1.015l-1.258-1.258a1.843 1.843 0 0 0-.033-.034L4.937 16.48a2.017 2.017 0 0 0-.034-.033Zm-.695.72a.718.718 0 0 0-.993 1.035l2.583 2.583a.718.718 0 0 0 1.036-.992l-2.626-2.627Zm10.488-7.238a.5.5 0 1 0-.707-.707L9.222 13.99a.5.5 0 1 0 .707.707l4.767-4.768Zm7.158 6.217a.5.5 0 0 1 0 .708L19.707 19l2.147 2.146a.5.5 0 0 1-.707.708L19 19.707l-2.146 2.147a.5.5 0 0 1-.707-.708L18.293 19l-2.146-2.146a.5.5 0 0 1 .707-.708L19 18.293l2.146-2.147a.5.5 0 0 1 .708 0Z"
    />
  </svg>
);

export default NoWeights;
